import { List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';
import BaseList from 'records/BaseList';

import {
  MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
  MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
  MAIN_COLOR_DESIGN_TEMPLATES_RESET_STATE,
} from 'actions/mainColorDesignTemplates';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MAIN_COLOR_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignTemplates(action.data),
    });
  },
  [MAIN_COLOR_DESIGN_TEMPLATES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function mainColorDesignTemplates(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
